import gql from 'graphql-tag'

export default gql`
  query LeaveImports($company: ID!, $offset: Int!, $limit: Int!) {
    leaveImports(company: $company, offset: $offset, limit: $limit) {
      leaveImports {
        id
        creator {
          id
          full_name: fullName
          avatar_url: avatarUrl
        }
        leave_count: leaveCount
        successful_count: successfulCount
        error_count: errorCount
        created_at: createdAt
        import_file_url: importFileUrl
        error_file_url: errorFileUrl
        can_undo: canUndo
        undone_by: undoneBy {
          id
          full_name: fullName
          avatar_url: avatarUrl
        }
        undone_at: undoneAt
      }
      totalLeaveImports
    }
  }
`
